var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small"},[_c('pie-chart',{staticStyle:{"padding":"7px"},attrs:{"height":300,"chart-data":_vm.CHARTDATA}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }